import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Interface, IPayload, IUIStore } from "./type";

const initialData: Interface = {
  open: false,
  data: {},
};
const initialState: IUIStore = {
  leadForm: initialData,
  branchGallery: initialData,
  menu: initialData,
  eventDetails: initialData,
  leadFormDrawer: initialData,
  video: initialData,
  eventVideos: initialData,
  resultView: initialData,
};
/**
 * Actions and Reducers
 */
const slice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    toggleModal: (store: IUIStore, { payload }: PayloadAction<IPayload>) => {
      const { key, data }: IPayload = payload;
      store[key] = data;
    },
    resetModals: () => {
      return initialState;
    },
  },
});

export const { toggleModal, resetModals } = slice.actions;

export default slice;
